import { useState } from "react";

/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";

/* MATERIAL TAILWIND COMPONENTS */
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

/* ICONS */
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const FAQAccordion = (props) => {
  return (
    <Accordion
      open={props.state}
      icon={
        props.state ? (
          <IoIosArrowUp className="w-4 h-4 text-black" />
        ) : (
          <IoIosArrowDown className="w-4 h-4 text-black" />
        )
      }
      className="mt-3 first:mt-0"
    >
      <AccordionHeader
        className={`bg-white border shadow border-greyBorder px-5 py-3 ${
          props.state ? "rounded-t-lg" : "rounded-lg"
        } text-md font-lato-bold text-black`}
        onClick={props.onClick}
      >
        {props.title}
      </AccordionHeader>
      <AccordionBody
        className={`p-5 bg-white ${
          props.state ? "border border-t-0 rounded-b-lg" : "rounded-none"
        } border-greyBorder `}
      >
        <p className="text-md font-source font-normal text-greyText leading-relaxed">
          {props.description}
        </p>
      </AccordionBody>
    </Accordion>
  );
};

const FrequentlyAskedQuestions = () => {
  const [accordion01, setAccordion01] = useState(false);
  const [accordion02, setAccordion02] = useState(false);
  const [accordion03, setAccordion03] = useState(false);
  const [accordion04, setAccordion04] = useState(false);
  const [accordion05, setAccordion05] = useState(false);

  return (
    <motion.div
      variants={animation}
      className="py-6 xl:py-12 lg:py-12 bg-[#F5F5F5] bg-opacity-50 shadow-inner"
    >
      <div className="container">
        <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl: gap-12 lg:gap-12">
          <div className="col-span-1">
            <h2 className="text-3xl xl:text-4xl lg:text-4xl font-roundo font-bold text-black">
              Frequently Asked Questions
            </h2>
            <h5 className="mt-2 w-4/5 text-xl font-source font-normal text-greyText">
              Find answers to common questions independently, avoiding the need
              for direct communication.
            </h5>
          </div>
          <div className="col-span-1">
            <FAQAccordion
              state={accordion01}
              onClick={() => setAccordion01(!accordion01)}
              title="What does the Alumni Connection Hub pricing include?"
              description="Our pricing includes a complete suite of features to manage and engage your alumni network—alumni onboarding, event management, donation tracking, job boards, communication tools, analytics, and more. We also provide a dedicated support team and onboarding assistance at no extra cost."
            />
            <FAQAccordion
              state={accordion02}
              onClick={() => setAccordion02(!accordion02)}
              title="Do you offer custom pricing for universities based on size or specific needs?"
              description="Yes! We understand that each institution is unique. Our pricing is flexible and can be tailored based on the number of alumni, required features, and engagement goals. Contact us for a custom quote that fits your university’s needs and budget."
            />
            <FAQAccordion
              state={accordion03}
              onClick={() => setAccordion03(!accordion03)}
              title="How does Alumni Connection Hub compare to others in terms of pricing?"
              description="Alumni Connection Hub is designed to be more affordable and transparent than most competitors, with no hidden charges. We offer more flexibility in plan customization, better value for mid-sized institutions, and unmatched customer support."
            />
            <FAQAccordion
              state={accordion04}
              onClick={() => setAccordion04(!accordion04)}
              title="Is there a free trial or demo available?"
              description="Absolutely. We offer a free 14-day trial with full access to all core features. You can also schedule a personalized demo with our team to explore how the platform can be customized for your institution."
            />
            <FAQAccordion
              state={accordion05}
              onClick={() => setAccordion05(!accordion05)}
              title="Are there any setup or onboarding fees?"
              description="No, we do not charge any setup or onboarding fees. Our goal is to make it as easy as possible for your university to get started. Our team will guide you through the initial setup and data migration—completely free of cost."
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FrequentlyAskedQuestions;
